import React from 'react';
import ShareButton from './ShareButton';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import usePlayersContext from "../hooks/usePlayersContext";
import Facebook from "./ShareButtons/Facebook";
import Twitter from "./ShareButtons/Twitter";
import Linkedin from "./ShareButtons/Linkedin";
import Pinterest from "./ShareButtons/Pinterest";

const Share = () => {
    const { showPopupShare, popupShare } = usePlayersContext();

    return (
        <>
            <ShareButton />
            {showPopupShare && (
                <div className="player-app__item-popup episode-player-share">
                    <button onClick={popupShare} className="player-app__close-popup">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M12 4L4 12M4 4L12 12"
                                stroke="black"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </button>
                    <Swiper
                        slidesPerView={2}
                        spaceBetween={10}
                        watchSlidesProgress={true}
                        allowTouchMove={false}
                        breakpoints={{
                            700: {
                                slidesPerView: 4,
                            },
                        }}
                        modules={[Navigation]}
                        navigation={{
                            arrows: true,
                        }}
                        className="player-app__swiper"
                    >
                        <SwiperSlide>
                            <Facebook />
                        </SwiperSlide>
                        <SwiperSlide>
                            <Twitter />
                        </SwiperSlide>
                        <SwiperSlide>
                            <Linkedin />
                        </SwiperSlide>
                        <SwiperSlide>
                            <Pinterest />
                        </SwiperSlide>
                    </Swiper>
                </div>
            )}
        </>
    );
};

export default Share;
